// File: frontend/src/pages/Plato/components/TemplateSelector/TemplateSelector.js

import React from 'react';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { BookOpen, BarChart, Network, Plus, X } from 'lucide-react';
import styles from './TemplateSelector.module.css';

const TemplateSelector = ({ templates, onSelect, onClose, selectedTemplate }) => {
  const { t } = useLanguage();
  
  const handleTemplateSelect = (template) => {
    console.log('Selecting template:', template);
    onSelect(template);
    onClose();
  };

  // Get icon component based on template
  const getTemplateIcon = (iconName) => {
    if (iconName === 'BookOpen') return <BookOpen size={18} />;
    if (iconName === 'BarChart') return <BarChart size={18} />;
    if (iconName === 'Network') return <Network size={18} />;
    return <BookOpen size={18} />;
  };

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={e => e.stopPropagation()}>
        <div className={styles.header}>
          <h3>{t('plato.template_selector.title')}</h3>
          <button className={styles.closeButton} onClick={onClose}>
            <X size={18} />
          </button>
        </div>
        <div className={styles.content}>
          {templates.map(template => (
            <button
              key={template.id}
              className={`${styles.templateButton} ${
                selectedTemplate?.id === template.id ? styles.selected : ''
              }`}
              onClick={() => handleTemplateSelect(template)}
            >
              <div className={styles.templateIcon}>
                {getTemplateIcon(template.icon)}
              </div>
              <div className={styles.templateInfo}>
                <div className={styles.templateName}>{template.name}</div>
                {template.description && (
                  <div className={styles.templateDescription}>{template.description}</div>
                )}
              </div>
            </button>
          ))}
          <button className={styles.createButton} disabled>
            <Plus size={18} />
            {t('plato.template_selector.create_new')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TemplateSelector;